<template>
  <q-select outlined :modelValue="modelValue" :label="label" @update:modelValue="$emit('update:modelValue', $event)"
    use-input hide-selected fill-input input-debounce="1000" :options="options"
    :error="error">
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          No results
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:error>
      <span v-for="err in errors" :key="err">{{ err }}</span>
    </template>
  </q-select>
</template>

<script setup>
import FuerzaVentaService from '@/services/FuerzaVentaService';
import { computed, ref, onMounted } from 'vue'
import { round } from 'mathjs'

const props = defineProps({
  modelValue: [String, Number],
  errors: [String, Array],
  label: [String]
});
defineEmits(['update:modelValue']);
const options = ref([]);
const error = computed(() => props?.errors && props?.errors?.length !== 0)
const abortFilterFn = () => console.log('delayed filter aborted')
onMounted(async () => {
  const response = await FuerzaVentaService.index();
  options.value = response.map(fv => ({ label: fv, value: fv }));
});
</script>
